export const env = {
    baseURL: process.env.REACT_APP_API_URL || 'https://api-politicadegenero.dpu.def.br/api/' // Produção
    //baseURL: process.env.REACT_APP_API_URL || 'https://api-hml-politicadegenero.dpu.def.br/api/' // Homologação
    //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/' //Local   
} 